import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-timeline-todo', {
  mixins: [eventListenerMixin],

  properties: {
    disabled: {
      type: Boolean,
      default: false,
    },
    todoId: String,
    todoGuid: String,
    url: String,
    startDate: String,
    endDate: String,
    timelineStartDate: String,
    popoverId: String,
  },

  connected() {
    this.wrapper = this.querySelector('.timeline-todo-wrapper');
    this.placeholder = document.querySelector('.timeline-todo-placeholder');
    this.sidebarTodo = document.querySelector(
      `tr-project-timeline-sidebar [data-hover-id="${this.id}"]`,
    );
    this.initDrag();

    if (!this.sidebarTodo) return;
    this.listenTo(this, {
      mouseenter: () => this.sidebarTodo.classList.add('hover'),
      mouseleave: () => this.sidebarTodo.classList.remove('hover'),
    });
  },

  initDrag() {
    const todo = this;
    const { wrapper } = todo;

    $(wrapper).draggable({
      axis: 'x',
      handle: '.drag-todo',
      snap: '.timeline-layout-column',
      snapTolerance: 24,
      cursor: 'move',
      distance: 12,
      start: (event, ui) => {
        todo.hideDependency();
        todo.classList.add('dragging');
        todo.placeholder.style.width = `${wrapper.offsetWidth}px`;
        todo.placeholder.style.left = `${ui.position.left}px`;
      },
      drag: (event, ui) => {
        todo.placeholder.style.left = `${ui.position.left}px`;
      },
      stop: () => {
        todo.classList.remove('dragging');
        todo.placeholder.style.width = 0;
        todo.placeholder.style.left = 0;
        todo.updateTodo(todo.getRange());
      },
    });

    function handleDragStart() {
      todo.hideDependency();
      todo.classList.add('dragging');
      todo.placeholder.style.width = `${wrapper.offsetWidth}px`;
      todo.placeholder.style.left = `${wrapper.offsetLeft}px`;
    }

    function handleDragStop(event) {
      const { target } = event;
      target.removeAttribute('style');
      todo.classList.remove('dragging');
      todo.placeholder.style.width = 0;
      todo.placeholder.style.left = 0;
      todo.updateTodo(todo.getRange());
    }

    const todoLeft = wrapper.offsetLeft;
    const todoWidth = wrapper.offsetWidth;
    $(todo)
      .find('.drag-handle.drag-left')
      .draggable({
        axis: 'x',
        grid: [48, 48],
        cursor: 'w-resize',
        start: handleDragStart,
        drag: (event) => {
          const { target } = event;
          const width = todoWidth - target.offsetLeft;
          const left = todoLeft + target.offsetLeft;

          if (width < 48) return;
          wrapper.style.width = `${width}px`;
          wrapper.style.left = `${left}px`;
          todo.placeholder.style.width = `${width}px`;
          todo.placeholder.style.left = `${left}px`;
        },
        stop: handleDragStop,
      });

    $(todo)
      .find('.drag-handle.drag-right')
      .draggable({
        axis: 'x',
        grid: [48, 48],
        cursor: 'e-resize',
        start: handleDragStart,
        drag: (event) => {
          const { target } = event;
          const width = 16 + target.offsetLeft; // 拖拽图标宽度 16px

          if (width < 48) return;
          wrapper.style.width = `${width}px`;
          todo.placeholder.style.width = `${width}px`;
        },
        stop: handleDragStop,
      });
  },

  getRange() {
    return `${this.getDateByPosition('left')},${this.getDateByPosition('right')}`;
  },

  getDateByPosition(direction) {
    const dayWidth = 48;
    let width = parseInt(this.wrapper.style.left, 10);
    if (direction === 'right') width = width + this.wrapper.offsetWidth - dayWidth;

    const days = Math.round(parseInt(width, 10) / dayWidth);
    return window
      .moment(this.timelineStartDate)
      .add(days, 'days')
      .format('YYYY-MM-DD');
  },

  updateTodo(range) {
    this.disabled = true;
    $.ajax({
      url: this.url,
      type: 'patch',
      dataType: 'script',
      data: {
        'todos_management[range]': range,
        timeline_start_date: this.timelineStartDate,
      },
    });
  },

  hideDependency() {
    [].forEach.call(
      document.querySelectorAll(`tr-project-timeline-dependency[parent-id="${this.todoId}"]`),
      el => el.classList.add('hide'),
    );
    [].forEach.call(
      document.querySelectorAll(`tr-project-timeline-dependency[child-id="${this.todoId}"]`),
      el => el.classList.add('hide'),
    );
  },

  disconnected() {
    this.stopListening();
  },
});
